import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import Circles from './circles'

const Cta = props => {
  const decor = (
    <span
      className={classnames([
        'button__decor button__decor--medium',
        { 'button__decor--reverse': props.reverse },
      ])}
    >
      <Circles size={96} />
    </span>
  )
  const contents = (
    <>
      {props.reverse && decor}
      <span>{props.children}</span>
      {!props.reverse && decor}
    </>
  )
  return React.createElement(
    props.tag,
    {
      className:
        'flex-container align-middle button button--reverse button--medium',
      ...props.attributes,
    },
    contents
  )
}

Cta.propTypes = {
  attributes: PropTypes.object,
  children: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.element,
    PropTypes.func,
  ]),
  reverse: PropTypes.bool,
  tag: PropTypes.oneOf(['a', 'button']).isRequired,
}

Cta.defaultProps = {
  attributes: {},
}

export default Cta
